import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { CheckPermission } from "../Permissions/CheckPermissions";
import ScrollImage from "../../assets/images/chevron-up.svg"
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";
import { highlightFirstMatch } from "../../Utils/Common";


const DeepLinkNavigation = (props) => {
  const sortOptions = [
    { id: 1, value: "date", label: "Date Created" },
    { id: 2, value: "name", label: "Name" },
  ];
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [showsScrolBtn,setShowScrolBtn]= useState(false)
  const [loading,setloading]=useState(true)
  const [sortBy, setSortBy] = useState("date");


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getNavigationData(token);
  }, []);

        useEffect(() => {
          const handleButtonVisibility=()=>{
            window.pageYOffset > 300 ? setShowScrolBtn(true) : setShowScrolBtn(false)
          }
          window.addEventListener("scroll",handleButtonVisibility)
          return(()=>{
            window.addEventListener("scroll",handleButtonVisibility)
          })

        },[]);

  const getNavigationData = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=deeplink&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setloading(false)   
        // Sort the array based on 'created_datetime' letest on top
        result?.deeplink_data.sort((a, b)=> {
          return new Date(b.created_datetime) - new Date(a.created_datetime);
        });
        setData(result?.deeplink_data);
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleSortBy =(item)=>{
   if (item === "name"){
    const sortedData = [...data].sort((a, b) => a.path_name.localeCompare(b.path_name));
    setData(sortedData)
   }else if(item === "date"){
    const sortedData = [...data].sort((a, b) =>
    new Date(b.created_datetime) - new Date(a.created_datetime)
   );
   setData(sortedData)
   }
  }
 
  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_id, token);
          setDelete(false);
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setSuccesAlert(false);
          props?.history.push("/deeplink-navigation");
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Deeplink Navigation deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=deeplink/delete&id=${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Deeplink Navigation" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={4}>
                      <Button
                        disabled={!CheckPermission("deeplink", "add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-deeplink-navigation");
                        }}
                      >
                        <FaPlus size={12} /> Add DeepLink Navigation
                      </Button>
                    </Col>
                    <Col md={8} className="d-flex justify-content-md-end">
                    <div className="mb-3" style={{ marginRight: 20 }}>
                          <label htmlFor="cars">Sort By</label>
                          <select
                            name="cars"
                            id="cars"
                            defaultValue={sortBy}
                            onChange={(e) => {
                              handleSortBy(e.target.value)
                              setSortBy(e.target.value);
                            }}
                            style={{
                              width: 150,
                              height: 35,
                              marginLeft: 10,
                              borderRadius: "2px",
                              color: "#706b6b",
                              border: "2px solid #EEEEEE",
                            }}
                            options={sortOptions}
                          >
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>
                                 {item?.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      <div>
                        <input
                          style={{
                            border: "2px solid rgb(238, 238, 238)",
                            width: "290px",
                            height: "35px",
                          }}
                          className="form-control"
                          placeholder="Search By Navigation..."
                          type="text"
                          id="page_input"
                          onChange={(e) => {
                            setSearchQuery(e.target.value.toLowerCase());
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  {loading ? <div role="status" style={{ textAlign: "center" }}>
                        <CircularProgress
                         size={50} value={100} color={"black"}
                        />
                      </div> :<div className="table-responsive mt-3">
                    <table
                      style={{ tableLayout: "fixed" }}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th style={{ width: "75%" }}>Navigation</th>
                          <th style={{ width: "8%" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data &&
                          data?.map((item, index) => {
                            if (searchQuery) {
                              const navigateToMatch = item?.navigate_to?.toLowerCase().includes(searchQuery);
                              const pathNameMatch = item?.path_name?.toLowerCase().includes(searchQuery);
                              if (!navigateToMatch && !pathNameMatch) {
                                return null;
                              }
                            }
                            return (
                              <tr key={index}>
                                <td>{highlightFirstMatch(item?.path_name, searchQuery)}</td>
                                <td>{highlightFirstMatch(item?.navigate_to, searchQuery)}</td>
                                <td>
                                  <Row>
                                    <div className="d-flex justify-content-around">
                                      {CheckPermission(
                                        "deeplink",
                                        "update"
                                      ) && (
                                        <div
                                          style={{
                                            width: 30,
                                            textAlign: "center",
                                          }}
                                          className="text-primary"
                                        >
                                          <a
                                            className="font-size-18"
                                            onClick={() => {
                                              props?.history?.push(
                                                "/add-deeplink-navigation",
                                                { edit: true, item: item }
                                              );
                                            }}
                                          ><FaPen /></a>
                                        </div>
                                      )}

                                      {CheckPermission(
                                        "deeplink",
                                        "delete"
                                      ) && (
                                        <div style={{ width: 30 }}>
                                          <Link
                                            to="#"
                                            className="px-3 text-danger"
                                          >
                                            <i
                                              className="font-size-18"
                                              onClick={() => {
                                                setItemForDelete(item);
                                                setDelete(true);
                                              }}
                                            ><FaRegTrashAlt /></i>
                                          </Link>
                                        </div>
                                      )}
                                    </div>
                                  </Row>
                                </td>
                              </tr>
                            );
                          })}
                {showsScrolBtn && <div
                        id="scrolToTop"
                          onClick={() => {
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                          }}
                          style={{
                            position: "fixed",
                            bottom: "60px", 
                            right: "60px",
                            color: "gray",
                            textAlign: "center",
                            cursor: "pointer",
                            fontSize: "4em",
                            lineHeight: 0,
                            textDecoration:"none",
                          }}
                        >
                          <img src={ScrollImage} alt="" 
                          style={{width: "40px",
                            background: "#34C38F",
                            borderRadius: "50%",
                            padding:"5px"}} />
                        </div>}
                      </tbody>
                    </table>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DeepLinkNavigation;
